import './marathon-rain.scss';
import React, { useState } from 'react';
import * as media from './marathon-rain-media';
import { Trans, useTranslation } from 'react-i18next';
import DashedDrawedSvg from '../../../../components/DashedDrawedSvg';
import StopMotionSvg from '../../../../components/StopMotionSvg';
import CommonButton from '../../../../components/button/button';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/all';
import useDeviceDetection from '../../../../hooks/useDeviceDetection';
const MarathonRain = () => {

    const { t } = useTranslation();
    const [isRtl, setIsRtl] = useState(1);
    const deviceType = useDeviceDetection();
    return (
        <div
            onClick={(e) => e.stopPropagation()} // Prevent click from closing modal
            className="marathon-rain-component">
            <section className='section-1'>
                <h1 className='gefen-program-header'>{t('gefen.maraton-rain.caption')}</h1>
                {/* <p className='gefen-program-number'>{t('gefen.maraton-rain.programLabel')}</p> */}
                {deviceType?.isMobile &&
                    <img src={media.martonRain} alt='' />
                }
            </section>

            <section className='section-2'>
                <div className='flex-column'>
                    <b><Trans i18nKey='gefen.maraton-rain.section1.headline'></Trans>  </b>
                    <p className='empthied-text'><Trans i18nKey='gefen.maraton-rain.section1.subHeadline'><span></span></Trans>  </p>
                    <p className='text-run'><Trans i18nKey='gefen.maraton-rain.section1.description'><span></span></Trans>            </p>
                </div>
                <img src={media.martonRain} alt='' />

            </section>
            {deviceType?.isMobile ?
                <svg xmlns="http://www.w3.org/2000/svg" width="243" height="202" viewBox="0 0 243 202" fill="none">
                    <path d="M213.1 197.309C195.139 196.04 50.0315 141.098 98.4245 119.3C209.035 69.4769 -16.1695 38.6318 54.8701 3.82626" stroke="#CA89FE" stroke-width="7" stroke-dasharray="9 9" />
                </svg> : <section className='section-3'>
                    <div className='transition-2' id="transition-2">
                        <DashedDrawedSvg
                            maskStrokDashArrayc='17 17'
                            svgWidth="180"
                            svgHeight="249"
                            strokeDasharray={420}
                            d="M25.5099 4.61879C-68.2301 47.5141 200.099 86.097 55.0366 147.482C-8.42956 174.339 157.301 242.559 178.946 244.164"
                            trigger='.section-3'
                            startTrigger="top 85%"
                            endTrigger="bottom 10%"
                            scroller={'.gefen-programs-backdrop  >div'}
                        />
                    </div>
                </section>
            }

            <section className='section-4'>
                <div className='flex'>
                    <img src={media.section3Media.img} alt='' />
                    <div className='flex-column'>
                        <p className='text-run'>
                            <Trans i18nKey='gefen.maraton-rain.section2'>
                                <span className='marked-text'>

                                </span>
                            </Trans>

                        </p>
                    </div>
                </div>
                <StopMotionSvg
                    shapes={media.section3Media.lines}
                    width={80}
                    height={132}
                    interval={500}
                />
            </section>

            {deviceType?.isMobile ?
                <svg xmlns="http://www.w3.org/2000/svg" width="193" height="173" viewBox="0 0 193 173" fill="none">
                    <path d="M29.8558 163.533C46.1754 165.4 152.882 109.297 118.361 88.7034C39.4584 41.6324 203.235 40.7927 153.611 8.82905" stroke="#CA89FE" stroke-width="7" stroke-dasharray="10.48 10.48" />
                </svg> : <section className='section-4-1'>
                    <DashedDrawedSvg
                        maskStrokDashArrayc='17.45 17.45'
                        svgWidth="124"
                        svgHeight="179"
                        strokeDasharray={320}
                        d="M109.26 4.28346C175.662 34.6687 -14.4117 61.9993 88.3445 105.482C133.301 124.506 15.9043 172.831 0.572506 173.968"
                        trigger='.section-4-1'
                        startTrigger="top 85%"
                        endTrigger="bottom 10%"
                        scroller={'.gefen-programs-backdrop  >div'}
                    />
                </section>
            }

            <section className='section-5'>
                <h5 className='sub-title'><Trans i18nKey='gefen.maraton-rain.section3.title'><span className='marked-text'></span></Trans> </h5>
                <p className='text-run'>{t(deviceType?.isMobile ? 'gefen.maraton-rain.section3.text-mobile' : 'gefen.maraton-rain.section3.text')} </p>
            </section>

            {deviceType?.isMobile ?
                <svg xmlns="http://www.w3.org/2000/svg" width="195" height="169" viewBox="0 0 195 169" fill="none"><path d="M182.649 156.842C182.436 140.417 113.281 41.6674 97.221 78.5166C60.5127 162.741 38.9556 0.387598 13.5282 53.6572" stroke="#CA89FE" stroke-width="7" stroke-dasharray="10.48 10.48"></path></svg> : <section className='section-6'>
                    <DashedDrawedSvg
                        maskStrokDashArrayc='17.45 17.45'
                        svgWidth="124"
                        svgHeight="179"
                        strokeDasharray={320}
                        d="M14.7403 4.75002C-51.6613 35.1353 138.412 62.4658 35.6558 105.949C-9.30106 124.973 108.096 173.297 123.428 174.434  "
                        trigger='.section-6'
                        startTrigger="top 85%"
                        endTrigger="bottom 10%"
                        scroller={'.gefen-programs-backdrop  >div'}
                    />
                </section>}

            <section className='section-7'>
                <h5 className='sub-title'><Trans i18nKey='gefen.maraton-rain.section4.title'><span className='marked-text'></span></Trans> </h5>
                <ul>
                    {
                        [1, 2, 3, 4].map(index => <li className={"bullet" + index} key={index}>
                            <div>
                                <img src={media.section7[index - 1]} alt='' />
                            </div>
                            <p className='text-run'> {t(`gefen.maraton-rain.section4.bullet${index}`)}</p>
                        </li>
                        )



                    }</ul>
            </section>

            {deviceType?.isMobile ?
                <svg xmlns="http://www.w3.org/2000/svg" width="177" height="161" viewBox="0 0 177 161" fill="none">
                    <path d="M29.6617 4.92665C43.7496 10.1287 187.614 98.4285 153.186 102.959C74.4966 113.313 175.892 148.163 125.746 156.877" stroke="#CA89FE" stroke-width="7" stroke-dasharray="9 9" />
                </svg> :
                <section className='section-8'>
                    <DashedDrawedSvg
                        maskStrokDashArrayc='17.45 17.45'
                        svgWidth="124"
                        svgHeight="179"
                        strokeDasharray={320}
                        d="M109.26 4.00636C175.662 34.3916 -14.4117 61.7222 88.3445 105.205C133.301 124.229 15.9043 172.554 0.572506 173.69"
                        trigger='.section-8'
                        startTrigger="top 85%"
                        endTrigger="bottom 10%"
                        scroller='.gefen-programs-backdrop  >div'
                    />
                </section>
            }

            <section className='section-9'>
                <h4 className='sub-title'>
                    <Trans i18nKey="gefen.maraton-rain.section5.headline">
                        <span className='marked-text'></span>
                    </Trans>
                </h4>
                <p>  <Trans i18nKey={deviceType?.isMobile ? 'gefen.maraton-rain.section5.contactInfoMobile' : 'gefen.maraton-rain.section5.contactInfo'}><span></span></Trans></p>
                <div className='flex'>
                    <CommonButton text={t('gefen.blended-tools.section5.ctaButton')} routePath='/contact-us' />
                    {media.section9Decorations.lines}
                </div>
                <img src={media.section9Decorations.image} alt='' />

            </section>
        </div >
    );
};

export default MarathonRain;